import Event from '@opsbase/lib-event';
import doNothing from '@opsbase/lib-general/utils/doNothing';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useWorkflowFindById from '@opsbase/react-gql-hooks/workflow/useWorkflowFindById';
import useWorkflowUpdate from '@opsbase/react-gql-hooks/workflow/useWorkflowUpdate';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import useNav from '@opsbase/web-nav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import React, { useCallback, useMemo } from 'react';
import WorkflowDialog from './WorkflowDialog';
export function WorkflowEditDialog() {
    const { id } = useParams();
    const { loading, data } = useWorkflowFindById({ variables: { id } });
    const updateWorkflow = useWorkflowUpdate();
    const { goBack } = useNav();
    const event = data === null || data === void 0 ? void 0 : data.event;
    const isOpType = useMemo(() => {
        return (event === Event.OP_COMPLETE ||
            event === Event.OP_DUE ||
            event === Event.OP_LATE ||
            event === Event.OP_MISSED ||
            event === Event.OP_SUBMITTED);
    }, [event]);
    const handleWorkflowEdit = useCallback(patch => {
        updateWorkflow({
            id: data === null || data === void 0 ? void 0 : data.id,
            patch,
        }, {
            optimisticResponse: {
                __typename: 'Mutation',
                updateWorkflow: {
                    __typename: 'Workflow',
                    ...data,
                    patch,
                },
            },
        }).catch(doNothing);
    }, [updateWorkflow, data]);
    const handleChangeTitle = useCallback(title => {
        handleWorkflowEdit({ title });
    }, [handleWorkflowEdit]);
    const handleClose = useCallback(() => {
        goBack();
    }, [goBack]);
    const self = useSelf();
    const editable = (isOpType && self.isAdmin) || self.isPrimary || self.isSuperUser;
    if (loading || !data)
        return null;
    return (React.createElement(Dialog, { size: DialogSize.XFULL_YFULL, title: data === null || data === void 0 ? void 0 : data.title, editableTitle: true, onChangeTitle: handleChangeTitle, padded: false, onClose: handleClose, scroll: true },
        React.createElement(WorkflowDialog, { workflow: data, onChange: handleWorkflowEdit, editable: editable })));
}
export default WorkflowEditDialog;
